// import { Error } from '../../core/classes';

/** The common default state */
export const DEFAULT_STATE = {
  isLoading: null,
  lastUpdated: null,
  invalidAfter: 0, // By default, the data is always outdated, never cached
  data: null,
  error: null,

  // TODO: Invalidate data, in case we need it some sunny day?
  // didInvalidate: false,
};

/**
 * Defines the reducers for each of the common action types.
 *
 * @param  {String} REQUEST - action type specific constant
 *                            @example: 'app/home/REQUEST_RECENT_EXHIBITIONS'
 * @param  {String} RECEIVE - (same as above)
 * @param  {String} FAIL    - (same as above)
 * @return {Object}         - all common handlers (Reducers)
 */
const getHandlers = ({ REQUEST, RECEIVE, FAIL }) => ({
  [REQUEST]: state => ({ ...state, isLoading: true }),
  [RECEIVE]: (state, action) => ({
    ...state,
    isLoading: false,
    lastUpdated: new Date().valueOf(),
    data: action.data,
    error: null,
    // didInvalidate: false,
  }),
  [FAIL]: (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  }),

  // TODO: Invalidate data, in case we need it some day
  // [INVALIDATE]: state => ({ ...state, didInvalidate: true }),
});

const createReducer = (initialState, handlers) => (
  state = initialState,
  action
) => {
  const handler = handlers[action.type];

  return handler ? handler(state, action) : state;
};

/**
 * Makes a common Reducer handlers and state shape.
 *
 * Most of the Entities have `fetch`, `receive`, `fail` (...) action creators
 * So this module gives the basic Reducer structure and handlers.
 *
 * It's extendable, so you can easily add your custom handlers.
 *
 * @param  {Object} actions - Holds a mapping of the entity specific actions,
 *                            @example: {
 *                              REQUEST: 'app/home/REQUEST_EXHIBITIONS',
 *                              RECEIVE: 'app/home/RECEIVE_EXHIBITIONS_SUCCESS',
 *                              FAIL: 'app/home/RECEIVE_EXHIBITIONS_FAIL',
 *                            }
 * @param {Object} initialState - Optional. Initial state of the Reducer.
 *                                If passed, it will extend (or overwrite)
 *                                the common DEFAULT_STATE
 * @param {Object} handlers     - Add custom Reducer action handlers.
 *                                If passed, it will extend (or overwrite)
 *                                the common `getHandlers()`
 * @returns {Function} Reducer
 */
export const makeReducer = ({ actions, initialState = {}, handlers }) => {
  const state = { ...DEFAULT_STATE, ...initialState };
  const combinedHandlers = { ...getHandlers(actions), ...handlers };

  return createReducer(state, combinedHandlers);
};



// WEBPACK FOOTER //
// ./src/core/make-reducer.js